import { Component } from '@angular/core';

@Component({
    selector: 'app-multiple-fu',
    imports: [],
    templateUrl: './multiple-fu.component.html',
    styleUrl: './multiple-fu.component.scss'
})
export class MultipleFuComponent {}